export default "__VITE_ASSET__BzZFhWhn__"